<template>
  <v-autocomplete :min-len='3' :wait="120" :items="items" v-model="item" ref="search" :get-label="getLabel" :component-item='template'
                  @update-items="updateItems" :auto-select-one-item="false" @change="changeItem" @item-selected="selectItem" :placeholder="placeholder">
  </v-autocomplete>
</template>

<script>
  import ItemTemplate from './ItemTemplate.vue'
  import { mapGetters } from 'vuex'
  export default {
    props: ['values', 'placeholder', 'value'],
    data () {
      return {
        item: null,
        items: [],
        template: ItemTemplate,
        cachedItems: []
      }
    },
    computed: {
      ...mapGetters(['pokemonError'])
    },
    methods: {
      rebuildCache () {
        this.cachedItems = (this.values || []).map(item => ({
          item,
          name: String(item.Name || '').toLowerCase()
        }))
      },
      getLabel (item) {
        if (item) {
          return item.Name
        }
        return ''
      },
      updateItems (text) {
        const search = String(text || '').toLowerCase().trim()
        if (!search) {
          this.items = []
          return
        }
        const result = []
        for (let i = 0; i < this.cachedItems.length; i++) {
          if (this.cachedItems[i].name.includes(search)) {
            result.push(this.cachedItems[i].item)
            if (result.length >= 5) break
          }
        }
        this.items = result
      },
      selectItem (item) {
        this.items = []
        this.$emit('input', item.ID)
        this.$emit('selectedItem', item)
      },
      changeItem (item) {
        this.$emit('input', null)
        this.$emit('change', item)
      }
    },
    watch: {
      values: {
        immediate: true,
        handler () {
          this.rebuildCache()
        }
      },
      value: {
        immediate: true,
        handler(val) {
          if (!val) {
             this.item = null
          } else if (this.values) {
             this.item = this.values.find(v => v.ID === val)
          }
        }
      },
      pokemonError: function (e) {
        if (e.error === 1 || e.error === 10) {
          this.item = null
        }
      }
    }
  }
</script>
